/**
 * Mock 模块：heart_voyage_invite_send
 * @see mockMd/heart_voyage_invite_send.md
 */
import type {InviteSendData} from '../types'

/** @see mockMd/heart_voyage_invite_send.md */
export const HeartVoyageInviteSendMock: InviteSendData = {
  err_msg: '',
  invite_id: 'inv_abc123',
}
